import Link from "@mui/material/Link";
import Stack from "@mui/material/Stack";
import { type NoahSyncedNotification } from "services/types/notifications";
import Typography from "@mui/material/Typography";
import ListItemText from "@mui/material/ListItemText";
import * as React from "react";

export default function NoahSyncedNotificationItem({
  title,
  description,
  extra,
}: NoahSyncedNotification) {
  const { patient_id } = extra;
  return (
    <ListItemText
      primary={title}
      secondary={
        <Stack component="span" gap={0.5}>
          <Typography component="span" sx={{ whiteSpace: "pre-line" }}>
            {description}
          </Typography>
          {patient_id && (
            <Link href={`/patients/${patient_id}/noah`} underline="hover">
              To Patient Noah Sessions
            </Link>
          )}
        </Stack>
      }
    />
  );
}
